import { createSelector } from '@reduxjs/toolkit';
import { selectUserSettingsState } from '../selectors';

export const selectDataFeeds = createSelector(selectUserSettingsState, (userSettings) => userSettings.dataFeeds);
